import { render, staticRenderFns } from "./ServiceUnavailable.vue?vue&type=template&id=468c1305&scoped=true&"
import script from "./ServiceUnavailable.vue?vue&type=script&lang=js&"
export * from "./ServiceUnavailable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceUnavailable.vue?vue&type=style&index=0&id=468c1305&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c1305",
  null
  
)

export default component.exports